import { Button, Grid, Tooltip } from "@mui/material";
import { ArrowBackIos, Download } from "@mui/icons-material";

const ManualLayout = () => {
  const host = window.location.hostname;
  const handleOnBackClick = () => {
    if (host.includes("int")) {
      window.location.replace(
        "https://portaleaziende-int.fastweb.it/altri-servizi"
      );
    } else {
      window.location.replace(
        "https://portaleaziende.fastweb.it/altri-servizi"
      );
    }
  };

  const handleDownloadManual = () => {
    let url = "https://" + host + "/manual/NNG_Manuale_Utente.pdf";
    window.open(url, "_blank");
  };

  return (
    <Grid container justifyContent={"space-between"}>
      <Button
        color="primary"
        startIcon={<ArrowBackIos />}
        onClick={handleOnBackClick}
      >
        Indietro
      </Button>
      <Tooltip title={"Scarica il manuale"} arrow>
        <Button
          color="primary"
          endIcon={<Download />}
          onClick={handleDownloadManual}
        >
          Manuale
        </Button>
      </Tooltip>
    </Grid>
  );
};

export default ManualLayout;
